<!-- FAD MASIVO DESKTOP -->
<div class="main-container-menu" *ngIf="isMobile === false  && isTablet === false && this.router.url != '/firma-digital-gratis' ">
    <div class="menu">
        <div class="item">
            <p [routerLink]="['/firma-digital-para-personas']" routerLinkActive="active">FAD® personal</p>
        </div>
        <div class="item">
            <p [routerLink]="['/firma-digital-para-empresas']" routerLinkActive="active">FAD® empresa</p>
        </div>
        <div class="item">
            <p [routerLink]="['/como-empezar-a-firmar-digitalmente']" routerLinkActive="active">Soporte</p>
        </div>
        <div class="item">
            <p [routerLink]="['/preguntas-frecuentes-de-la-firma-digital-fad']" routerLinkActive="active">FAQs</p>
        </div>
        <div class="item">
            <button mat-button [matMenuTriggerFor]="menu">
                <div style="color: white" class="button-language-container">
                    ESP
                    <img src="assets/images/arrow_drop.png" alt="arrow">
                </div>
            </button>
            <mat-menu #menu="matMenu">
                <br><br>
                <button mat-menu-item>
                    <a (click)="changeLanguage()" style="color: white">POR</a>
                </button>
            </mat-menu>
        </div>
        <div class="item">
      
        </div>
    </div>
    <div class="actions" *ngIf="!inSession() && userDataM() === null">
        <div class="item">
            <p id="boton_menu_inicio_sesion" [routerLink]="['/inicia-sesion']" (click)="login(2)">Firmar Ahora</p>
        </div>
        <div class="item gratisFirmas">
            <p id="boton_menu_prueba_gratis" (click)="login(1)">
                Prueba gratuita
            </p>
        </div>
    </div>
    <div class="actions" *ngIf="inSession() && userDataM() !== null">
        <div class="item" (mouseover)="over()">
            <p *ngIf="mensaje === 0" (click)="goToBackOffice()">
                {{userDataM().name}} <br> {{userDataM().lastName}}
            </p>
            <p *ngIf="mensaje === 1" (click)="goToBackOffice()">
                Portal FAD®
            </p>
        </div>
        <div class="item">
            <p (click)="login()">Cerrar Sesión</p>
        </div>
    </div>
</div>
<div class="main-container-menu-est" *ngIf="isMobile === false  && isTablet === false && this.router.url == '/firma-digital-gratis'">
    <div class="menu">
        <div class="item">
            <p [routerLink]="['/firma-digital-para-personas']" routerLinkActive="active">FAD® personal</p>
        </div>
        <div class="item">
            <p [routerLink]="['/firma-digital-para-empresas']" routerLinkActive="active">FAD® empresa</p>
        </div>
        <div class="item">
            <p [routerLink]="['/como-empezar-a-firmar-digitalmente']" routerLinkActive="active">Soporte</p>
        </div>
        <div class="item">
            <p [routerLink]="['/preguntas-frecuentes-de-la-firma-digital-fad']" routerLinkActive="active">FAQs</p>
        </div>
        <div class="item">
            <button mat-button [matMenuTriggerFor]="menu">
                <div style="color: white" class="button-language-container">
                    ESP
                    <img src="assets/images/arrow_drop.png" alt="arrow">
                </div>
            </button>
            <mat-menu #menu="matMenu">
                <br><br>
                <button mat-menu-item>
                    <a (click)="changeLanguage()" style="color: white">POR</a>
                </button>
            </mat-menu>
        </div>
        <div class="item">
      
        </div>
    </div>
    <div class="actions" *ngIf="!inSession() && userDataM() === null">
        <div class="item">
            <p id="boton_menu_inicio_sesion" [routerLink]="['/inicia-sesion']" (click)="login(2)">Firmar Ahora</p>
        </div>
        <div class="item gratisFirmas">
            <p id="boton_menu_prueba_gratis" (click)="login(1)">
                Prueba gratuita
            </p>
        </div>
    </div>
    <div class="actions" *ngIf="inSession() && userDataM() !== null">
        <div class="item" (mouseover)="over()">
            <p *ngIf="mensaje === 0" (click)="goToBackOffice()">
                {{userDataM().name}} <br> {{userDataM().lastName}}
            </p>
            <p *ngIf="mensaje === 1" (click)="goToBackOffice()">
                Portal FAD®
            </p>
        </div>
        <div class="item">
            <p (click)="login()">Cerrar Sesión</p>
        </div>
    </div>
</div>

<!-- FAD MASIVO MOVIL -->
<div class="main-container-menu-res" *ngIf=" isMobile === true || isTablet === true ">
    <div class="menu-res">
        <div class="header-item" (click)="openMenu()">
            <img src="assets/images/m/menu_izq.png">
        </div>
        <div class="header-item" [routerLink]="['/']">
            <img src="assets/images/m/fad_logo.png">
        </div>

    </div>
    <div class="menu">
        <div id="boton_menu_prueba_gratis_movil" *ngIf="!inSession() && userDataM() === null" class="menu-btn" style="cursor: pointer" (click)="login(1)">
            PRUEBA GRATIS
        </div>
        <div *ngIf="inSession() && userDataM() !== null" class="menu-btn">
            Hola {{userDataM().name}}
        </div>
        <div class="menu-btn"></div>
        <div class="menu-btn" (click)="login(2)" style="cursor: pointer" *ngIf="!inSession() && userDataM() === null">
            FIRMAR AHORA
        </div>
        <div class="menu-btn" (click)="login()" style="cursor: pointer" *ngIf="inSession() && userDataM() !== null">
            CERRAR SESIÓN
        </div>
    </div>
</div>
